import { render, staticRenderFns } from "./EditDrivers.vue?vue&type=template&id=70a0ce61&"
import script from "./EditDrivers.vue?vue&type=script&lang=ts&"
export * from "./EditDrivers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports